"use client";

import React, { useEffect, useState } from "react";
// import { useNavigate } from 'react-router-dom'
// import api from '../../lib/api.interceptor'
// import { setThankYouData } from '../../store/features/projectSlice'
import { toast } from "react-toastify";
import { useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import api from "@/helper/api.interceptor";
// import { setThankYouData } from "@/store/features/projectSlice";
// import "../InquiryForm/InquiryForm.css";
import "./Vendor_form.css";

function Vendor_form({ countryList }) {
  // const countryList = useSelector((state) => state.project.countryList);
  const formRef = useRef(null);
  // const navigate = useNavigate()
  const router = useRouter();
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [files, setFiles] = useState({
    product_details_catalogue_upload: null,
    gst_attach_upload: null,
    iso_attach_upload: null,
    pan_attach_upload: null,
    msme_attach_upload: null,
    address_attach_upload: null,
  });
  const [errors, setErrors] = useState({});
  const [showDropdown1, setShowDropdown1] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [loading, setLoading] = useState(false);

  const [vendorData, setVendorData] = useState({
    name: "",
    contact_person: "",
    email: "",
    contact_no: "",
    country_code: "91",
    flag: "https://flagcdn.com/w40/in.webp",

    company_profile: null, // attachment
    gst_no: "",
    pan_no: "AAAAA0000A",
    // is_quality_audits: "N.A",
    bank_details: "N.A",
    message: "",

    master_user_id: 632,
    logged_in_master_user_id: 632,
  });

  //   const [vendorData, setVendorObj] = useState({})
  const [search, setSearch] = useState("");
  const [country1, setCountry1] = useState({
    code: "91",
    flag: "https://flagcdn.com/w40/in.webp",
  });

  const [country2, setCountry2] = useState({
    code: "91",
    flag: "https://flagcdn.com/w40/in.webp",
  });

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    if (type === "file") {
      setVendorData((prev) => ({ ...prev, [name]: files[0] }));
      setErrors((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    let newValue = value;

    // ✅ FORCE UPPERCASE FOR GST & PAN
    if (name === "gst_no") {
      newValue = value.toUpperCase();
    }

    setVendorData((prev) => ({ ...prev, [name]: newValue }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleNext = () => {
    const validationErrors = validate(step);
    if (Object.keys(validationErrors).length === 0) {
      // console.log(vendorData)
      setStep(step + 1);
      setSearch("");
      if (formRef.current) {
        const offset = 100;
        const topPosition =
          formRef.current.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: topPosition,
          behavior: "smooth",
        });
      }
    } else {
      setErrors(validationErrors);
      // console.log(validationErrors)
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);

      // ✅ SHOW FIRST ERROR
      const firstError = Object.values(validationErrors)[0];
      toast.error(firstError);

      return;
    }

    setLoading(true);

    try {
      const fd = new FormData();

      fd.append("name", vendorData.name);
      fd.append("email", vendorData.email);
      fd.append("contact_no", `${country1.code} ${vendorData.contact_no}`);
      fd.append("contact_person", vendorData.contact_person);
      fd.append("gst_no", vendorData.gst_no);
      fd.append("PAN_no", vendorData.pan_no);
      // fd.append(
      //   "quailty_audits_done",
      //   vendorData.is_quality_audits === "yes" ? "1" : "0",
      // );
      fd.append("bank_details", vendorData.bank_details);
      fd.append("msg", vendorData.message);
      fd.append("company_profile", vendorData.company_profile);

      const response = await fetch(
        "https://work.reecosys.com/rameshwar_inquiries/vendor_registration_form.php",
        {
          method: "POST",
          body: fd,
        },
      );

      const result = await response.json();

      if (result?.success === 1 || result?.status === "success") {
        toast.success("Vendor registration submitted successfully");
        setVendorData({
          name: "",
          contact_person: "",
          email: "",
          contact_no: "",
          company_profile: null,
          gst_no: "",
          // pan_no: "",
          // is_quality_audits: "",
          // bank_details: "",
          message: "",
          country_code: "91",
          flag: "https://flagcdn.com/w40/in.webp",
        });
        setErrors({});
      } else {
        toast.error(result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      toast.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Delete",
    ];
    if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleCountrySelect1 = (code, flag) => {
    setCountry1({ code, flag });
    setShowDropdown1(false);
  };

  const handleCountrySelect2 = (code, flag) => {
    setCountry2({ code, flag });
    setShowDropdown2(false);
  };

  const validate = () => {
    const errors = {};

    const gst = vendorData.gst_no.trim().toUpperCase();
    // const pan = vendorData.pan_no.trim().toUpperCase();

    if (!vendorData.name.trim()) errors.name = "Name is required";

    if (!vendorData.contact_person.trim())
      errors.contact_person = "Contact person required";

    if (!vendorData.email.trim()) errors.email = "Email is required";

    if (!vendorData.contact_no.trim())
      errors.contact_no = "Contact number required";
    else if (!/^[0-9]{10}$/.test(vendorData.contact_no))
      errors.contact_no = "Enter valid 10 digit number";

    if (!vendorData.company_profile)
      errors.company_profile = "Company profile required";

    // ✅ GST FORMAT ONLY
    const GST_REGEX =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    if (!gst) {
      errors.gst_no = "GST Number is required";
    } else if (!GST_REGEX.test(gst)) {
      errors.gst_no = "Invalid GST Number format";
    }

    // ✅ PAN FORMAT ONLY
    // const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    // if (!pan) {
    //   errors.pan_no = "PAN Number is required";
    // } else if (!PAN_REGEX.test(pan)) {
    //   errors.pan_no = "Invalid PAN Number format";
    // }

    // if (!vendorData.is_quality_audits.trim())
    //   errors.is_quality_audits = "Required";

    // if (!vendorData.bank_details.trim())
    //   errors.bank_details = "Bank details required";

    // if (!vendorData.message.trim()) errors.message = "Message required";

    return errors;
  };

  const handleFileChange = async (e, fileName) => {
    const { name, files: selectedFiles } = e.target;
    const file = selectedFiles[0];
    const uploadData = {
      upload_type: fileName,
      [name]: file,
    };

    const response = await api.VendorFileUpload(uploadData);

    if (response.success == 1) {
      // console.log('✅ Upload Success:', response)
      // Update the main form data (to show file name, etc.)
      setFiles((prev) => ({ ...prev, [name]: file }));
      setVendorData((prev) => ({
        ...prev,
        [fileName]: response.file_name, // or store response URL if needed
      }));
    } else {
      console.error("❌ Upload failed:", response);
    }
  };

  const getInputClass = (value, hasError) => {
    let cls = "";

    if (
      (typeof value === "string" && value.trim() !== "") ||
      (typeof value === "number" && !isNaN(value)) ||
      (typeof value === "boolean" && value === true)
    ) {
      cls += " ng-not-empty";
    }

    if (hasError) cls += " no-empty";

    return cls.trim();
  };
  const [formSubmitted, setFormSubmitted] = useState(false);

  return (
    <>
      <div
        className="detail-form-sec8 vendor_form_wrapper"
        ref={formRef}
        onClick={(e) => {
          e.stopPropagation();
          setShowDropdown1(false);
        }}
      >
        <div className="">
          <form
            onSubmit={handleSubmit}
            className="contact_form inner-flex detali-inqury-sec8 relative"
          >
            <div className="form_wrapper contact_form">
              {/* Name */}
              <div className="contact_lable">
                <input
                  type="text"
                  name="name"
                  value={vendorData.name}
                  onChange={handleChange}
                  className={`form-control  ${getInputClass(
                    vendorData.name,
                    errors.name,
                  )} ${errors.name ? "error" : ""}`}
                />
                <label className="md-lable">Full Name<sup>*</sup></label>
              </div>

              {/* Contact Person */}
              <div className="contact_lable">
                <input
                  type="text"
                  name="contact_person"
                  value={vendorData.contact_person}
                  onChange={handleChange}
                  className={`form-control  ${getInputClass(
                    vendorData.contact_person,
                    errors.contact_person,
                  )} ${errors.contact_person ? "error" : ""}`}
                />
                <label className="md-lable">Contact Person<sup>*</sup></label>
              </div>

              {/* Email */}
              <div className="contact_lable">
                <input
                  type="email"
                  name="email"
                  value={vendorData.email}
                  onChange={handleChange}
                  className={`form-control  ${getInputClass(
                    vendorData.email,
                    errors.email,
                  )} ${errors.email ? "error" : ""}`}
                />
                <label className="md-lable">Email Address<sup>*</sup></label>
              </div>

              {/* Contact Number (same UI logic) */}
              <div className="contact_lable relative">
                <input
                  id="contact_no"
                  name="contact_no"
                  type="tel"
                  minLength={10}
                  maxLength={10}
                  autoComplete="off"
                  className={`form-control  contact-form ${getInputClass(
                    vendorData.contact_no,
                    errors.contact_no,
                  )} ${errors.contact_no ? "error" : ""}`}
                  value={vendorData.contact_no}
                  onChange={handleChange}
                  onKeyDown={handlePhoneKeyDown}
                />
                <label className="md-lable contact_code" htmlFor="contact_no">
                  Mobile Number<sup>*</sup>
                </label>

                <div className="conatct_number_input">
                  <div
                    className="country_code_data alc "
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowDropdown1(!showDropdown1);
                    }}
                  >
                    <div className="contact_country_flag">
                      <img src={country1.flag} alt="flag" />
                    </div>
                    <div>&nbsp; +{country1.code}</div>
                    <div>
                      <span className="material-symbols-outlined">
                        stat_minus_1
                      </span>
                    </div>
                  </div>
                </div>

                {showDropdown1 && (
                  <div
                    className="contact_country_flag country_code_list_data active"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="search_c-code">
                      <input
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    <ul>
                      {countryList
                        ?.filter(
                          (c) =>
                            c.nicename
                              .toLowerCase()
                              .includes(search.toLowerCase()) ||
                            c.phonecode.includes(search),
                        )
                        .map((c, idx) => (
                          <li
                            key={idx}
                            onClick={() =>
                              handleCountrySelect1(c.phonecode, c.flag)
                            }
                          >
                            <div>
                              <img src={c.flag} alt="flag" />
                              <span className="display_country_code">
                                +{c.phonecode}
                              </span>
                              {c.nicename}
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Company Profile Upload */}
              <div className="relative contact_lable upload_input">
                <input
                  id="company_profile"
                  name="company_profile"
                  type="file"
                  accept=".pdf"
                  className={`upload-button-wrapper-input form-control  upload_file_input ${errors.company_profile ? "error" : ""
                    }`}
                  onChange={(e) => {
                    const file = e.target.files?.[0] || null;

                    setErrors((prev) => ({ ...prev, company_profile: "" }));

                    if (!file) {
                      setVendorData((prev) => ({
                        ...prev,
                        company_profile: null,
                      }));
                      return;
                    }

                    setVendorData((prev) => ({
                      ...prev,
                      company_profile: file,
                    }));
                  }}
                />

                {/* Custom Upload UI (same as resume) */}
                <div
                  className={`upload-button-wrapper ${vendorData.company_profile ? "active" : ""
                    } ${errors.company_profile ? "error" : ""
                    }`}
                >
                  <p className="transition_0s">
                    {vendorData.company_profile
                      ? vendorData.company_profile.name
                      : "Upload Company Profile / Product Catalogue*"}
                  </p>

                  <span style={{ marginLeft: "auto" }}>
                    <img src="/images/vendor/upload-vendor.png" alt="" />
                  </span>
                </div>

                {/* {errors.company_profile && (
                  <p className="error-msg capitalize">
                    {errors.company_profile}
                  </p>
                )} */}

                {/* {!errors.company_profile && (
                  <p className="other_message">Allow only PDF file.</p>
                )} */}
              </div>

              {/* GST No */}
              <div className="contact_lable">
                <input
                  type="text"
                  name="gst_no"
                  maxLength={15}
                  value={vendorData.gst_no}
                  onChange={handleChange}
                  className={`form-control  ${getInputClass(
                    vendorData.gst_no,
                    errors.gst_no,
                  )} ${errors.gst_no ? "error" : ""}`}
                />
                <label className="md-lable">GST Number<sup>*</sup></label>
              </div>

              {/* PAN No */}
              {/* <div className="contact_lable">
                <input
                  type="text"
                  name="pan_no"
                  value={vendorData.pan_no}
                  maxLength={10}
                  onChange={handleChange}
                  className={`form-control  ${getInputClass(
                    vendorData.pan_no,
                    errors.pan_no,
                  )} ${errors.pan_no ? "error" : ""}`}
                />
                <label className="md-lable">PAN Number<sup>*</sup></label>
              </div> */}

              {/* Quality Audit */}
              {/* <div className=" quality-audit"> */}
                {/*                 
                <select
                  name="is_quality_audits"
                  value={vendorData.is_quality_audits}
                  onChange={handleChange}
                  className={`form-control  ${vendorData.is_quality_audits ? "ng-not-empty" : ""
                    } ${errors.is_quality_audits ? "error" : ""}`}
                >
                  <option value="" style={{ display: "none" }}></option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
                <label className="md-lable">Are quality audits done?*</label> */}
                {/* <div className="quality-audit-wrapper">
                  <p className="quality-title regular-fonts">
                    Are Quality Audits Done?
                  </p>

                  <div className="quality-options">
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="is_quality_audits"
                        value="yes"
                        checked={vendorData.is_quality_audits === "yes"}
                        onChange={handleChange}
                      />
                      <span className="custom-radio"></span>
                      <span className="regular-fonts">Yes</span>
                    </label>

                    <label className="radio-option">
                      <input
                        type="radio"
                        name="is_quality_audits"
                        value="no"
                        checked={vendorData.is_quality_audits === "no"}
                        onChange={handleChange}
                      />
                      <span className="custom-radio"></span>
                      <span className="regular-fonts">No</span>
                    </label>
                  </div>

                  {errors.is_quality_audits && (
                    <p className="error-msg">{errors.is_quality_audits}</p>
                  )}
                </div> */}
              {/* </div> */}

              {/* Bank Details */}
              {/* <div className="contact_lable">
                <textarea
                  type="text"
                  name="bank_details"
                  value={vendorData.bank_details}
                  onChange={handleChange}
                  rows={4}
                  className={`form-control  ${getInputClass(
                    vendorData.bank_details,
                    errors.bank_details,
                  )} ${errors.bank_details ? "error" : ""}`}
                />
                <label className="md-lable md-lable-bank">Bank Details</label>
              </div> */}

              {/* Message */}
              <div className="contact_lable">
                <textarea
                  name="message"
                  value={vendorData.message}
                  onChange={handleChange}
                  rows={4}
                  className={`form-control `}
                />
                <label className="md-lable md-lable-msg">Message</label>
              </div>

              {/* Submit */}
              {/* <div className="filled-div-button button-div">
                <button
                  type="submit"
                  className="reecosys-template-button button-style-primary"
                  disabled={loading}
                >
                  <p>{loading ? "Please wait..." : "Submit"}</p>
                </button>
              </div> */}
              <div className="submit-button border-div-venus-wrapper submit-button-contact form_button section-paragraph">
                <button
                  className="reecosys-template-button button-style-secondary section-paragraph"
                  type="submit"
                  tabIndex={7}
                >
                  {formSubmitted &&
                    Object.values(errors).every((err) => err === "") ? (
                    <span>Please Wait...</span>
                  ) : (
                    <span className="section-paragraph">Submit</span>
                  )}
                  {/* <span className="material-symbols-outlined">
                    arrow_forward
                  </span> */}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Vendor_form;
